// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--5f87c";
export var cost__block = "style-module--cost__block--f3d1a";
export var cost__blockContent = "style-module--cost__block-content--2b557";
export var cost__blockHeader = "style-module--cost__block-header--b49b3";
export var cost__blockItem = "style-module--cost__block-item--a6932";
export var cost__blocks = "style-module--cost__blocks--327e7";
export var cost__prices = "style-module--cost__prices--03152";
export var cost__pricesBlock = "style-module--cost__prices-block--ce143";
export var cost__pricesButton = "style-module--cost__prices-button--1efa2";
export var cost__pricesBuy = "style-module--cost__prices-buy--8777a";
export var cost__pricesHeader = "style-module--cost__prices-header--7fa4b";
export var cost__pricesItem = "style-module--cost__prices-item--bec9d";
export var cost__pricesList = "style-module--cost__prices-list--2389a";
export var cost__pricesPrice = "style-module--cost__prices-price--050c2";
export var cost__pricesText = "style-module--cost__prices-text--c80cb";
export var cost__undertext = "style-module--cost__undertext--5ee1f";
export var month = "style-module--month--cc942";